/**
 * Cams API
 * Cams
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface TransactionListOutputDto { 
    id?: number;
    amount?: number;
    transactionNumber?: string | null;
    creationDate?: string;
    transactionDate?: string;
    status?: string | null;
    type?: string | null;
    accountNumber?: string | null;
    memberId?: string | null;
    origin?: string | null;
    memberName?: string | null;
    initiatedUser?: string | null;
    error?: string | null;
}

